import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=455cb3c4&scoped=true"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=455cb3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455cb3c4",
  null
  
)

export default component.exports